export default "__VITE_ASSET__g2213snD__"